/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfDataSourceResultDtoOfDeviceDto } from '../../models/platform-api-result-of-data-source-result-dto-of-device-dto';
import { PlatformGetAllQueryOfDataSourceResultDtoOfDeviceDto } from '../../models/platform-get-all-query-of-data-source-result-dto-of-device-dto';

export interface PostDevicesQueryDatasource$Params {
      body: PlatformGetAllQueryOfDataSourceResultDtoOfDeviceDto
}

export function postDevicesQueryDatasource(http: HttpClient, rootUrl: string, params: PostDevicesQueryDatasource$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfDataSourceResultDtoOfDeviceDto>> {
  const rb = new RequestBuilder(rootUrl, postDevicesQueryDatasource.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfDataSourceResultDtoOfDeviceDto>;
    })
  );
}

postDevicesQueryDatasource.PATH = '/api/devices/query/datasource';
